import { StringParam, useQueryParam } from 'use-query-params';
import Auth from '../../../services/AuthService';
import useSetUser from '../../../hooks/useSetUser';
import useError from '../../../hooks/useError';

import { getAccessToken, getTmfToken } from '../helpers/LoginServices';

const useLogin = () => {
  const [par] = useQueryParam('par', StringParam);
  const isClient = typeof window !== 'undefined';
  const setUser = useSetUser();
  const { setError } = useError();

  return async () => {
    if (isClient && par) {
      // PAR LOGIN
      const response = await Auth.autoProcess(par)
        .then(([user]) => {
          if (user.isValid) {
            setUser(user);
            return { status: 200 };
          }
          throw new Error('invalid user');
        })
        .catch(() => ({ status: 400 }));
      return response;
    }
    // SSO LOGIN
    const { accessToken, refreshToken } = await getAccessToken();

    if (accessToken) {
      try {
        Auth.setSessionRefreshToken(refreshToken);
        const { data: user, status } = await getTmfToken(accessToken);

        if (status === 200) setUser(user);
        return {
          status,
          accessToken,
          refreshToken,
          user,
          'gen-user': user['gen-user'],
        };
      } catch (e) {
        if (e.message && e.message.includes('403')) {
          return { status: 403, accessToken };
        }
        setError(true);
        if (e.response) return { status: e.response.status, accessToken };
        return { status: 500, accessToken };
      }
    } else return { status: 404 };
  };
};

export { getAccessToken, getTmfToken };

export default useLogin;
